import * as React from 'react';

import { getLocale } from '@rematter/common/locale';
import { formatMoney, GroupRow, Row } from '@rematter/ui-web';

import { useTranslations } from '../../i18n/useTranslations';

import { InvoiceRecord } from '~/modules/finance/types';

type Props = GroupRow<InvoiceRecord>;

//
// ⚛️ ⚛️ ⚛️ INVOICE GROUP CELL ⚛️ ⚛️ ⚛️
//
export const InvoiceGroupCell: React.FC<Props> = ({ children }) => {
  // Translations
  const t = useTranslations();

  const accountName =
    children[0]?.accountName || t.invoices.list.groupHeader.unknownAccount;
  const invoiceCount = children.length;
  const pendingTotal = children
    .filter((invoice) => invoice.status === 'Pending')
    .reduce((sum, invoice) => sum + invoice.amount.amount, 0);
  const currencyCode = children[0]?.amount.currencyCode;
  const formattedTotal = currencyCode
    ? formatMoney(pendingTotal, currencyCode, getLocale())
    : '';

  return (
    <Row gap3 className="@InvoiceGroupCell font-medium">
      <span>{accountName}</span>
      <Row gap1 className="text-sm font-normal text-neutral/50">
        &bull;
        <span>{t.invoices.list.groupHeader.invoiceCount(invoiceCount)}</span>
        {formattedTotal && (
          <>
            &bull;
            <span>
              {t.invoices.list.groupHeader.outstanding(formattedTotal)}
            </span>
          </>
        )}
      </Row>
    </Row>
  );
};
